module.exports = __webpack_public_path__ + "static/media/ORANGE APPOINT.b96b791d.svg";